<template>
  <div class="table-cell table-cell-empty"></div>
</template>

<script>
export default {
  name: 'PulsTableEmptyCell',
  props: {
    group: {
      type: Object,
      required: true
    }
  }
}
</script>
